export default "__VITE_ASSET__DA4YgyjE__"